import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import { AuthProvider } from "@/auth";
import { installAudioGate } from "@/lib/audio-gate";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import { Login, Register } from "@/pages/Auth";
import { NewBattle, BattleRoom } from "@/pages/Battle";
import { Leaderboard, Tournament, MyProfile } from "@/pages/Leaderboard";
import { Subscribe, SubscribeSuccess } from "@/pages/Subscribe";
import Admin from "@/pages/Admin";
import Feed from "@/pages/Feed";
import { CypherLauncher, CypherReel } from "@/pages/Cypher";
import Share from "@/pages/Share";
import Studio from "@/pages/Studio";
import Charts from "@/pages/Charts";
import TrackSubmit from "@/pages/TrackSubmit";
import TrackDetail from "@/pages/TrackDetail";
import MyTracks from "@/pages/MyTracks";
import HowItWorks from "@/pages/HowItWorks";
import Rappers from "@/pages/Rappers";
import RapperProfile from "@/pages/RapperProfile";
import Inbox from "@/pages/Inbox";
import PvpDetail from "@/pages/PvpDetail";
import UploadHero from "@/pages/UploadHero";
import MonthlyCrown from "@/pages/MonthlyCrown";
import About from "@/pages/About";
import Story from "@/pages/Story";
import Foreman from "@/pages/Foreman";
import Shelf from "@/pages/Shelf";
import OpenPersona from "@/pages/OpenPersona";
import SmartKet from "@/pages/SmartKet";
import Porch from "@/pages/Porch";
import Superuser from "@/pages/Superuser";
import BreakBoard from "@/pages/BreakBoard";
import SmartKetBoard from "@/pages/SmartKetBoard";
import SmartKetJoin from "@/pages/SmartKetJoin";
import SmartKetMarketerNew from "@/pages/SmartKetMarketerNew";
import SmartKetMarketers from "@/pages/SmartKetMarketers";
import SmartKetSlip from "@/pages/SmartKetSlip";
import SmartKetMySlips from "@/pages/SmartKetMySlips";
import SmartKetTerms from "@/pages/SmartKetTerms";
import SmartKetHowItWorks from "@/pages/SmartKetHowItWorks";

// One-mic-at-a-time gate — pauses siblings whenever a new audible track
// starts. Protects against "both rappers singing at the same time."
installAudioGate();

function App() {
 return (
 <AuthProvider>
 <BrowserRouter>
 <Layout>
 <Routes>
 <Route path="/" element={<Home />} />
 <Route path="/login" element={<Login />} />
 <Route path="/register" element={<Register />} />
 <Route path="/battles" element={<MyProfile />} />
 <Route path="/battles/new" element={<NewBattle />} />
 <Route path="/battles/:id" element={<BattleRoom />} />
 <Route path="/feed" element={<Feed />} />
 <Route path="/cypher" element={<CypherLauncher />} />
 <Route path="/cypher/:id" element={<CypherReel />} />
 <Route path="/share" element={<Share />} />
 <Route path="/studio" element={<Studio />} />
 <Route path="/studio/shelf" element={<Shelf />} />
 <Route path="/openpersona" element={<OpenPersona />} />
 <Route path="/smartket" element={<SmartKet />} />
 <Route path="/porch" element={<Porch />} />
<Route path="/superuser" element={<Superuser />} />
 <Route path="/admin/plan" element={<BreakBoard />} />
 <Route path="/smartket/board" element={<SmartKetBoard />} />
 <Route path="/smartket/join" element={<SmartKetJoin />} />
 <Route path="/smartket/marketer/new" element={<SmartKetMarketerNew />} />
 <Route path="/smartket/marketers" element={<SmartKetMarketers />} />
 <Route path="/smartket/slip" element={<SmartKetSlip />} />
 <Route path="/smartket/slips" element={<SmartKetMySlips />} />
 <Route path="/smartket/terms" element={<SmartKetTerms />} />
 <Route path="/smartket/how-it-works" element={<SmartKetHowItWorks />} />
 <Route path="/charts" element={<Charts />} />
 <Route path="/charts/submit" element={<TrackSubmit />} />
 <Route path="/tracks/:id" element={<TrackDetail />} />
 <Route path="/my-tracks" element={<MyTracks />} />
 <Route path="/how-it-works" element={<HowItWorks />} />
 <Route path="/rappers" element={<Rappers />} />
 <Route path="/rapper/:name" element={<RapperProfile />} />
 <Route path="/inbox" element={<Inbox />} />
 <Route path="/pvp/:id" element={<PvpDetail />} />
 <Route path="/leaderboard" element={<Leaderboard />} />
 <Route path="/tournament" element={<Tournament />} />
 <Route path="/me" element={<MyProfile />} />
 <Route path="/subscribe" element={<Subscribe />} />
 <Route path="/subscribe/success" element={<SubscribeSuccess />} />
 <Route path="/admin" element={<Admin />} />
 <Route path="/admin/foreman" element={<Foreman />} />
 <Route path="/upload-hero" element={<UploadHero />} />
 <Route path="/crown" element={<MonthlyCrown />} />
 <Route path="/about" element={<About />} />
 <Route path="/story" element={<Story />} />
 </Routes>
 </Layout>
 </BrowserRouter>
 </AuthProvider>
 );
}

export default App;
